import React, { useState } from 'react'
import VentaAExportadoresView from '../../components/ventaAExportadores/VentaAExportadoresView'
import { connect } from 'react-redux'
import CamposBusqueda from '../../components/listados/CamposBusqueda'
import { ToastContainer } from 'react-toastify'
import { parseEntityId } from '../../../../models/entity'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_VENTA_A_EXPORTADOR } from '../../../../config/forms'
import { obtenerVentasAExportador } from '../../actions/controlDiario'

function VentaAExportadores (props) {
  const { obtenerVentasAExportador, change: formChange } = props
  const [show, setShow] = useState(false)

  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaDesde', fechaD)
    formChange('fechaHasta', fechaH)
  }

  const handleSubmit = () => {
    const { fechaDesde, fechaHasta, exportadorBusqueda, cerealBusqueda } = props
    const exportador = parseEntityId(exportadorBusqueda) || null
    const cereal = (cerealBusqueda && (cerealBusqueda.trim() !== 'UNDEF') && cerealBusqueda.trim()) || null
    obtenerVentasAExportador(fechaDesde, fechaHasta, exportador, cereal)
    setShow(true)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div style={{ margin: '2% auto' }} >
        <h5>Ventas a exportadores</h5>
        <p>Seleccione los filtros de búsqueda</p>
      </div>
      <CamposBusqueda actualizarFechas={actualizarFechas} handleSubmit={handleSubmit} />
      { show && <VentaAExportadoresView /> }
    </>
  )
}

const selector = formValueSelector(FORM_VENTA_A_EXPORTADOR)

const mapStateToProps = (state) => ({
  exportadorBusqueda: selector(state, 'exportador'),
  cerealBusqueda: selector(state, 'cereal'),
  fechaDesde: selector(state, 'fechaDesde'),
  fechaHasta: selector(state, 'fechaHasta')
})

const mapActionsToProps = {
  obtenerVentasAExportador
}

const withReduxForm = reduxForm({
  form: FORM_VENTA_A_EXPORTADOR
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(VentaAExportadores))
